<template>
  <q-card bordered flat class="column full-height full-width">
    <q-form @submit.prevent="update">
      <q-card-section>
        <div class="text-h6">Обновления выполнения задачи {{ performTask?.task.code }} от
          {{ dayJs.utc(performTask?.executionTime).local().format("L") }}
        </div>
      </q-card-section>
      <q-separator />
      <q-card-section>
        <q-input v-model="startTime" label="Дата начала">
          <template v-slot:prepend>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                <q-date v-model="startTime" mask="YYYY-MM-DD HH:mm">
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Закрыть" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>

          <template v-slot:append>
            <q-icon name="access_time" class="cursor-pointer">
              <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                <q-time v-model="startTime" mask="YYYY-MM-DD HH:mm" format24h>
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Закрыть" color="primary" flat />
                  </div>
                </q-time>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
        <q-input v-model="executionTime" label="Дата выполнения">
          <template v-slot:prepend>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                <q-date v-model="executionTime" mask="YYYY-MM-DD HH:mm">
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Закрыть" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>

          <template v-slot:append>
            <q-icon name="access_time" class="cursor-pointer">
              <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                <q-time v-model="executionTime" mask="YYYY-MM-DD HH:mm" format24h>
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Закрыть" color="primary" flat />
                  </div>
                </q-time>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>

      </q-card-section>

      <q-card-actions>
        <q-btn no-caps label="Обновить" :loading="isUpdate" type="submit" color="primary" />
      </q-card-actions>
    </q-form>
  </q-card>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { usePerformTask, useUpdatePerformTask } from "../../composables/performTask";
import { useRoute, useRouter } from "vue-router";
import { useDayJs } from "../../composables/dayjs";
import { useEventBus } from "@vueuse/core";
import { taskKey } from "../../util/events";

const taskEvent = useEventBus(taskKey)
const router = useRouter()
const route = useRoute()
const dayJs = useDayJs()
const projectId = computed(() => Number(route.params.projectId))
const performTaskId = computed(() => Number(route.params.performTaskId))
const taskId = computed(() => Number(route.params.taskId))
const executionTime = ref("")
const startTime = ref("")


const { data: performTask, isFetching, execute } = usePerformTask(projectId, performTaskId)

const updateBody = computed(() => ({
  executionTime: dayJs(executionTime.value).utc().format(),
  startTime: dayJs(startTime.value).utc().format(),
  photoCount: null,
  description: null
}))
const { isFetching: isUpdate, execute: executeUpdate } = useUpdatePerformTask(projectId, performTaskId, updateBody)


watch(performTask, val => {
  startTime.value = val?.startTime ? dayJs.utc(val?.startTime).local().format("YYYY-MM-DD HH:mm") : ""

  executionTime.value = dayJs.utc(val?.executionTime).local().format("YYYY-MM-DD HH:mm")
})

async function update() {
  await executeUpdate(true)
  await execute(true)
  taskEvent.emit('refresh')
  await router.push(`/projects/${projectId.value}/tasks/${taskId.value}/perform/${performTaskId.value}`)
}
</script>

<style scoped></style>